import React from "react"
import { useNavigate } from "react-router-dom"

const HandleNavigation = ({endpoint, children}) => {

    const navigate = useNavigate()

    const handleClick = () => {
        navigate(endpoint)
    }

    return (
        <span onClick={handleClick}>
            {children}
        </span>
    )
}

export default HandleNavigation